import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { NGXLogger } from 'ngx-logger';
import { REDIRECT_URLS_STORAGE_KEY } from '../gsw-redirect/gsw-redirect.component';

@Component({
  imports: [MatIcon, MatTooltip, TranslocoPipe, MatIconButton],
  selector: 'app-return-to-redirect-button',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (redirectUrls.length > 0) {
      <button
        mat-icon-button
        (click)="returnToRedirect()"
        aria-label="Return to Redirect"
        [matTooltip]="'RETURN_TO_REDIRECT' | transloco"
      >
        <mat-icon>u_turn_left</mat-icon>
      </button>
    }
  `,
})
export class ReturnToRedirectButtonComponent implements AfterViewInit {
  private logger = inject(NGXLogger);

  private readonly redirectStorageKey = REDIRECT_URLS_STORAGE_KEY;

  // Array of redirect URLs stored in session storage.
  redirectUrls: string[] = [];

  ngAfterViewInit(): void {
    this.loadStoredRedirectUrls();
    // if none were found, check again after a short delay (avoid race condition)
    if (this.redirectUrls.length === 0) {
      setTimeout(() => {
        this.loadStoredRedirectUrls();
      }, 3000); // 3 second delay
    }
  }

  private loadStoredRedirectUrls() {
    const stored = JSON.parse(
      sessionStorage.getItem(this.redirectStorageKey) || '{}'
    ) as Record<string, string>;
    const arrayValues = Object.values(stored);
    if (arrayValues.length > 0) {
      this.logger.debug('Stored redirect URLs:', stored);
    } else {
      this.logger.debug('No redirect URLs found in session storage.');
    }
    this.redirectUrls = Object.values(stored);
  }

  /**
   * Returns to the last redirect URL stored in session storage.
   */
  returnToRedirect(): void {
    const urls = this.redirectUrls;
    const lastUrl = urls.length > 0 ? urls[urls.length - 1] : null;
    if (lastUrl) {
      this.logger.debug(`Returning to redirect URL: ${lastUrl}`);
      window.location.assign(lastUrl);
    }
  }
}
